module.exports = __webpack_public_path__ + "static/media/lady.9176f9a6.jpg";